<template>
  <div class="member-list-container">
    <div class="search media">
      <div class="media-body">
        <search-input
          @search="searchMember"
          :placeholder="$t('label.search_home')"
        ></search-input>
      </div>
      <div class="ml-3">
        <filter-dropdown
          :header="'คัดกรองสถานะ'"
          :rows="rows"
          :type="'radio'"
          @filterSubmit="onFilterChange"
        ></filter-dropdown>
      </div>
    </div>
    <div class="col p-0 member-list">
      <home-navigation :homes="filterHomes" />
      <infinite-loading
        @infinite="infiniteHandler"
        spinner="spiral"
        ref="infiniteLoading"
      >
        <span slot="no-results" />
        <span slot="no-more" />
      </infinite-loading>
    </div>
    <home-summary
      :homes="homes"
      v-if="!isLoading && (keyword === '' && filterCategory === '')"
    />
  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import SearchInput from "@/components/helper/SearchInput";
import FilterDropdown from "@/components/helper/Dropdown";
import HomeNavigation from "./HomeNavigation";
import HomeSummary from "./HomeSummary";

export default {
  components: {
    SearchInput,
    InfiniteLoading,
    FilterDropdown,
    HomeNavigation,
    HomeSummary
  },
  data() {
    return {
      isLoading: true,
      homes: [],
      filterCategory: "",
      keyword: "",
      rows: [
        {
          key: "",
          value: "ทั้งหมด"
        },
        {
          key: "active",
          value: this.$t("feature.member.active")
        },
        {
          key: "inactive",
          value: this.$t("feature.member.in_active")
        }
      ]
    };
  },
  computed: {
    filterHomes() {
      let filterHome = this.homes;
      switch (this.filterCategory) {
        case "active":
          filterHome = this.homes.filter(m => m.isActive);
          break;
        case "inactive":
          filterHome = this.homes.filter(m => !m.isActive);
          break;
        default:
          break;
      }
      return filterHome.filter(m => m.addressNo.includes(this.keyword));
    }
  },
  watch: {},
  methods: {
    async loadHomes() {
      let projectId = localStorage.getItem("projectId");
      if (this.$route.params.homeId && this.$route.params.homeId !== "all") {
        const member = await this.loadMember(this.$route.params.homeId);
        projectId = member.projectId;
      }
      return axios
        .get(
          `${
            process.env.HOST
          }/admin/member-management/projects/${projectId}/homes`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            },
            params: {}
          }
        )
        .then(res => {
          if (res.data) {
            const homes = res.data;
            return homes;
          }
          return [];
        });
    },
    loadMember(homeId) {
      return axios
        .get(
          `${process.env.HOST}/admin/member-management/homes/${homeId}/members`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        )
        .then(result => result.data);
    },
    infiniteHandler($state) {
      this.isLoading = true;
      this.loadHomes()
        .then(homes => {
          this.homes = homes;
          this.$emit("homesChange", homes);
          this.isLoading = false;
          $state.complete();
        })
        .catch(() => {
          this.isLoading = false;
          $state.complete();
        });
    },
    searchMember(keyword) {
      this.keyword = keyword;
    },
    onFilterChange(category) {
      this.filterCategory = category;
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px;
}
.member-list-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.member-list {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/member/HomeList.vue